module.exports = __webpack_public_path__ + "img/icon.3a05c9bb.png";